import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const DispatchNeighborhood = ({data}) => {
  useEffect(() => {
    const values = data.slice(0,5).map(i => i.qty);
    const labels = data.slice(0,5).map(i => i.dispatch_factneighborhood);

    GraphicUtils.barChart('dispatch-neighborhood', values, labels, false, true, 3);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, "Despachos por bairros");

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">Despachos por bairros {data?.length >= 5 ? ' (TOP 5)' : ''}</span>
        <div className="mt-3" id="dispatch-neighborhood"></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default DispatchNeighborhood;